/**
 * Price Table
 */

export default function IncomingInvoice() {
    const selectors = {
        'wrapper' : '.incoming-flow'
    };

    this.init = () => {
        this.handleMessageSlideUp();
        this.handleInvoiceSlideUp();
    };

    this.handleMessageSlideUp = () => {
        const items = jQuery(selectors.wrapper).find('.message');
        if(!items.length) return;
        let currentIndex = 0;

        function showNextItem() {
            items.each((index, item) => {
                item.classList.remove('visible');
            });

            items[currentIndex].classList.add('visible');

            currentIndex = (currentIndex + 1) % items.length;
        }

        setInterval(showNextItem, 3000);
        showNextItem();
    }

    this.handleInvoiceSlideUp = () => {
        const items = jQuery(selectors.wrapper).find('.invoice-papers .papers .paper');
        if(!items.length) return;
        let currentIndex = 0;

        function showNextItem() {
            items.each((index, item) => {
                item.classList.remove('visible');
            });

            items[currentIndex].classList.add('visible');

            currentIndex = (currentIndex + 1) % items.length;
        }

        setInterval(showNextItem, 2000);
        showNextItem();
    }



}
